// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2IGmF","title":"ClientReferral_title__35PjP","itemText":"ClientReferral_itemText__35HIH"};